<template>
  <div class="home">
    <div class="start-btn" v-if="!isGameStart" @click="gameStart()">START</div>

    <div v-if="isGameStart">
      <!-- Debug Mode -->
      <!-- <div class="section-question">{{ questionString }} | {{ answer }}</div> -->
      <div class="section-question">{{ questionString }}</div>
      <div class="section-answer">
        <input
          class="input-answer"
          type="number"
          ref="inputAnswer"
          pattern="\d*"
          v-model.number="userAnswer"
          v-on:keyup.enter="updateQuestion()"
          autofocus
        />
        <span class="info" v-show="compareAnswer">
          <span class="btn" @click="updateQuestion()">Next</span>
        </span>
      </div>
      <div style="display: flex; gap: 20px; align-items: center;
        justify-content: center; margin: 15px 0;">
        <span>All: {{ completedCount }}</span>
        <span v-if="completed.length > 0">Now: {{ completed.length }}</span>
      </div>
      <div>Time: {{ elapsedTime }}</div>
      
      <div class="completed-list" v-for="q in completed" :key="q">
        {{ q }}
      </div>
    </div>

  </div>
</template>

<script>
function getRandomHex() {
  const randVal = Math.floor(Math.random() * 255) + 1;
  const hex = randVal.toString(16).toUpperCase();
  return {
    quesString: `Hex ${hex} = ?`,
    answer: randVal,
  };
}

function getRandomBinary() {
  const randVal = Math.floor(Math.random() * 256) + 1;
  const binary = randVal.toString(2).padStart(8, '0');
  return {
    quesString: `Bin ${binary.slice(0, 4)} ${binary.slice(4, 8)} = ?`,
    answer: randVal,
  };
}

function getRandomAddition() {
  const randValLeft = Math.floor(Math.random() * 999) + 1;
  const randValRight = Math.floor(Math.random() * 999) + 1;
  const sum = randValLeft + randValRight;
  return {
    quesString: `${randValLeft} + ${randValRight} = ?`,
    answer: sum,
  };
}

function getRandomMultiply() {
  const randValLeft = Math.floor(Math.random() * 25) + 1;
  const randValRight = Math.floor(Math.random() * 25) + 1;
  const product = randValLeft * randValRight;
  return {
    quesString: `${randValLeft} × ${randValRight} = ?`,
    answer: product,
  };
}

function getRandomContinuousAdd() {
  const randVal = () => (Math.floor(Math.random() * 10) + 1) * 5;
  const times = 5;
  const numbers = [];
  let answer = 0;
  for (let index = 0; index < times; index += 1) {
    const genRandVal = randVal();
    numbers.unshift(genRandVal);
    answer += genRandVal;
  }

  return {
    quesString: `${numbers.join(' + ')} = ?`,
    answer,
  };
}

// import HelloWorld from '@/components/HelloWorld.vue';
export default {
  name: 'Home',
  data() {
    return {
      questionString: 'Hex FF = ?',
      answer: 255,
      userAnswer: '',
      completed: [],
      completedCount: 0,
      isGameStart: false,
      gameStartTime: null,
      questionStartTime: null,
      elapsedTime: '00:00:00',
      timer: null,
    };
  },
  mounted() {
    // 從 localStorage 讀取完成次數
    const savedCount = localStorage.getItem('subayaku-completed-count');
    if (savedCount) {
      this.completedCount = parseInt(savedCount, 10) || 0;
    }
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  computed: {
    compareAnswer() {
      return this.answer === this.userAnswer;
    },
  },
  components: {},
  watch: {
    userAnswer() {
      this.updateQuestion();
    },
  },
  methods: {
    gameStart() {
      this.isGameStart = !this.isGameStart;
      if (this.isGameStart) {
        this.gameStartTime = Date.now();
        this.questionStartTime = Date.now();
        this.startTimer();
      }
      this.updateQuestion();
    },
    startTimer() {
      this.timer = setInterval(() => {
        const elapsed = Date.now() - this.gameStartTime;
        const hours = Math.floor(elapsed / 3600000);
        const minutes = Math.floor((elapsed % 3600000) / 60000);
        const seconds = Math.floor((elapsed % 60000) / 1000);
        this.elapsedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }, 1000);
    },
    formatQuestionTime(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000);
      const seconds = Math.floor((milliseconds % 60000) / 1000);
      return `(${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')})`;
    },
    updateQuestion() {
      const quesBankObject = [
        getRandomHex,
        getRandomBinary,
        getRandomAddition,
        getRandomMultiply,
        getRandomContinuousAdd];

      if (this.answer === this.userAnswer) {
        const questionTime = Date.now() - this.questionStartTime;
        const timeStr = this.formatQuestionTime(questionTime);
        this.completed.unshift(`${this.questionString.replace('?', this.answer)} ${timeStr}`);
        this.completedCount += 1;
        // 只將完成次數儲存到 localStorage
        localStorage.setItem('subayaku-completed-count', this.completedCount.toString());
        const quesObject = quesBankObject[Math.floor(Math.random() * quesBankObject.length)]();
        this.answer = quesObject.answer;
        this.questionString = quesObject.quesString;
        this.userAnswer = '';
        this.questionStartTime = Date.now();
        this.$refs.inputAnswer.focus();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.section-question {
  background-color: skyblue;
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
  font-size: 1.5rem;
}

.section-answer {
  margin-top: 15px;
  padding: 3px;
}

.input-answer {
  padding: 5px;
  font-size: 1.25rem;
}

.info {
  margin: 10px;
  font-size: 1.25rem;
}

.btn {
  background-color: lightseagreen;
  color: blanchedalmond;
  padding: 8px;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    background-color: seagreen;
  }
}

.completed-list {
  width: 95%;
  margin: 0 auto;
  margin-top: 15px;
  line-height: 1rem;
  text-align: center;
}

.start-btn{
  /* creative by https://codepen.io/reulison/pen/WNNVPZq */
  font-family: 'Press Start 2p';
  font-size: 3rem;
  text-align: center;
  display: inline-block;
  margin-top: 100px;
  font-weight: bold;
  padding: 15px 30px ;
  background-color: lightgray;
  text-shadow: -1px -1px black, 1px 1px white;
  color: gray;
  border-radius: 7px;
  box-shadow: 0 .2em gray;
  cursor: pointer;

  &:active{
    box-shadow: none;
    position: relative;
    top: .2em;
  }
}
</style>
